import * as yup from "yup";

export const submitEvidenceStep1Schema = yup.object().shape({
  first_name: yup.string().required("The field is required."),
  last_name: yup.string().required("The field is required."),
  client_email: yup.string().email("E-mail must be valid").required("The field is required."),
  address: yup.string().required("The field is required"),
  county: yup.string().required("The field is required"),
});
